export default "__VITE_ASSET__9c8174fc__"